export default __webpack_public_path__ + "static/media/Mystery_Cube_345.8cbdec77.png";